import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { approvalService } from 'src/app/services/approval.service';
import styles from "../../../assets/json/styles.json";
import portData13 from "../../../assets/json/vessel_details_8feb_11am.json";
import { DialogComponent } from '../dialog/dialog.component';
import { trailService } from 'src/app/services/trail.service';

@Component({
  selector: 'app-map-container',
  templateUrl: './map-container.component.html',
  styleUrls: ['./map-container.component.css']
})
export class MapContainerComponent implements OnInit {
  countryRestriction = {
    latLngBounds: {
      north: 85.0,
      south: -85.0,
      west: -180.0,
      east: 180.0
    },
    strictBounds: true
  };

  style=styles;
  lat = 29.756068;
  lng = -95.060537;
  zoom: number = 1;
  markers;
  userLocationMarkerAnimation: string;
  simpleDialog: MatDialogRef<DialogComponent>;

  constructor(private appService:approvalService,private dialogModel: MatDialog, private trailService: trailService) {
    this.appService.currentApprovalStageMessage.subscribe(data => this.markers = data);
    console.log(this.markers)
   }

  mapReading() {
    this.userLocationMarkerAnimation = 'DROP';
  }

  onMouseOver(infoWindow, $event: MouseEvent) {
    infoWindow.open();

  }

  onMouseOut(infoWindow, $event: MouseEvent) {
    infoWindow.close();
  }

  dialog(lat, lng,mmsi,ship) {
    this.trailService.fetchData(mmsi)
  .subscribe((data:any) => {
    console.log(data)
    this.trailService.updateApprovalMessage(data);
  });
    // this.clickedMarker(lat, lng, id);
    // let data = portData13.filter(
    //   m=> m.id == id
    // )
    // this.appService.updateApprovalMessage(data);
    // this.zone.run(() => {
      this.simpleDialog = this.dialogModel.open(DialogComponent,{
        data:{
          // id: id,
          lat: lat,
          lng: lng,
          // color: position_updated_within_7_days,
          // rot: last_known_position_heading,
          mmsi:mmsi,
          ship:ship
        },
        position: {
          left: '10px',
          top: '10px',
        }
      });
    // });

  }
  

  ngOnInit(): void {
    // this.appService.currentApprovalStageMessage.subscribe(result => {
    //   this.markers = result; // this set's the marker to the default observable value
    // });
  }

}
